module.exports = __webpack_public_path__ + "static/media/item-description.e94dcedb.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Tutorial/images/item-description.svg
 ** module id = 882
 ** module chunks = 0
 **/